export default {
  noSamePass: 'La password è diversa dalla password di conferma',
  loginSuccess: 'accesso effettuato con successo',
  registerSuccess: 'Registrazione avvenuta con successo',
  isHaveAccount: 'Hai già un account?',
  login: 'Accedi',
  logout: 'Disconnetti',
  forgetPass: 'Hai dimenticato la password?',
  register: 'Registrati',
  registered: 'Già registrato,',
  emailTips: 'E-mail',
  password: 'Password',
  pwdErr: 'Password errata.',
  confirmPass: 'Conferma password',
  countryTips: 'Seleziona il tuo paese',
  inviteCodeTips: "Inserisci il codice d'invito (opzionale)",
  verifyEmpty: 'Le informazioni inserite non possono essere vuote',
  verifyEmail: 'Inserisci un formato e-mail corretto',
  verifyPass: 'La password deve contenere tra 6 e 20 caratteri e deve includere lettere e numeri',
  confirmText: 'Ho letto e accetto',
  verifyCode: 'Codice di verifica',
  verifyUrl: 'Inserisci un formato URL corretto',
  loginPwd: 'Password di accesso',
  editPwd: 'Modifica password',
  changePwd: 'Cambia password di accesso',
  setPwd: 'Imposta password',
  and: 'e',
  privacyStatement: '《informativa sulla privacy》',
  confirm: 'Conferma',
  cancel: 'Annulla',
  editSuccess: 'Modifica avvenuta con successo',
  email: 'E-mail',
  emailCode: 'Codice di verifica',
  newPwd: 'Nuova password',
  button: {
    search: 'Cerca',
    query: 'VERIFICA ORA',
    reset: 'Ripristina',
    submit: 'Invia',
    submitOrder: 'Invia ordine',
    save: 'Salva',
  },
  holder: {
    select: 'seleziona',
    startTime: 'Ora inizio',
    endTime: 'Ora fine',
    max: 'massimo',
    min: 'minimo',
    inputContent: 'Inserisci il contenuto',
    inputEmailAccount: 'Inserisci un account e-mail valido',
  },
  back: 'Bentornato!',
  continueGoogle: 'Continua con Google',
  notAccount: 'Non hai un account?',
  signNow: 'Iscriviti ora',
  termService: 'Termini di servizio',
  privacyPolicy: 'Politica sulla privacy',
  helpCenter: 'Centro assistenza',
  readPrivacy: 'Ho già letto e accetto',
  verifyAccept: "non hai letto l'accordo",
  accountSecurity: "Sicurezza dell'account",
  loginNow: 'Accedi ora',
  resetPsd: 'Reimposta password',
  verifiedEmail: 'Verifica e-mail',
  unverified: 'non verificato',
  emailVerification: 'Verifica e-mail',
  verifyMsg:
    "La tua e-mail non è stata verificata, quindi al momento non siamo in grado di completare l'operazione di acquisto. Verifica la tua e-mail nel centro personale.",
  sendVerificationEmail: 'Invia e-mail di verifica',
  linkHasExpired: 'Il link è scaduto!',
  hasSendEmail: "Abbiamo inviato l'e-mail di verifica",
  shippingFeeEstimation: 'Stima delle spese di spedizione',
  homeText: 'Pagina principale',
  loginBgMsg: 'Unisciti al Discord di acbuy per ottenere maggiori vantaggi',
  registerTitleMsg: 'INIZIA IL TUO VIAGGIO',
  registerBgMsg: 'I nuovi utenti si registrano per ricevere {coupon} + coupon di spedizione',
  announcement: 'Annuncio',
  formAnnouncementMsg:
    'Un nuovo modello per il programma di affiliazione, modello di commissione a doppio pacco, usalo per fare soldi e risparmiare',
  incorrectAmount: "L'importo del prelievo deve essere maggiore di 0",
  readPrivacy1: 'Ho letto',
  andAgree: 'e accetto',
  aboveContent: 'il contenuto sopra',
  purchasingNotice: 'Avviso di acquisto',
  afterSaleService: 'servizio post-vendita',
  uniOrderAgreeText:
    "Il link che hai inviato in questa pagina appartiene a link di prodotti di terze parti (come Xianyu, Xiaohongshu, Bilibili, ecc.) e acbuy può solo aiutarti a trovare il venditore del link per la consultazione, l'acquisto e l'organizzazione dei servizi di consegna logistica di terze parti. acbuy non può distinguere tra la qualità e l'autenticità del prodotto e devi assumerti i rischi correlati prima di effettuare un ordine.",
  excludeFees:
    'Avviso importante: le spese di spedizione internazionali verranno calcolate separatamente.',
  selectProductBtn: 'Seleziona i prodotti dal mio magazzino',
}
